import Config from '@/config'

const generateQRCodePresentation = (presentation, user) => {
  let linkAudience = `${window.location.protocol}//${Config.audienceLink}/${presentation.uniqueAccessCode}`
  if (user.plan === 'white-label' && user.whiteLabelLink) {
    linkAudience = `https://${user.whiteLabelLink}/${presentation.uniqueAccessCode}`
  }
  return linkAudience
}

export default {
  generateQRCodePresentation,
}
